import consumer from "./consumer";

let subscription = null;

document.addEventListener("turbolinks:load", () => {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }

  const el = document.querySelector("[data-waitlist-restaurant-id]");
  if (!el) return;

  subscription = consumer.subscriptions.create(
    { channel: "WaitlistChannel" },
    {
      received(data) {
        if (!data.html) return;
        const target = document.querySelector('[data-waitlist-poller-target="content"]');
        if (!target) return;
        if (target.querySelector('.collapse.show')) return;
        target.innerHTML = data.html;
      }
    }
  );
});
